import { render } from "./SessionExpirationDialog.vue?vue&type=template&id=265cc2bc"
import script from "./SessionExpirationDialog.vue?vue&type=script&lang=js"
export * from "./SessionExpirationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__